import { Component } from '@angular/core';

@Component({
  selector: 'app-page-contato',
  templateUrl: './page-contato.component.html',
  styleUrls: ['./page-contato.component.scss'],
})
export class PageContatoComponent {}
